<template>
<div>
      <div class="layout-breadcrumb">
        <Breadcrumb>
            <BreadcrumbItem to="/">
                <Icon type="social-buffer-outline" style="color:#fff"></Icon> 
                <span style="color:#fff">采购业务流程</span>
            </BreadcrumbItem>
        </Breadcrumb>
      </div>

      <div class="layout-content" >

          <div class="layout-content-main" style="min-width:980px;padding: 20px;margin-left:60px;">
             
            <div class="flowChart">
                <ul>
                   <li style="margin-bottom: 30px;">
                        <div class="startBorder">
                          
                        </div>
                        <div class="arrowBox">
                            <div id="triangle-facing-right"></div>
                        </div>
                        <div class="flowPart">
                          <a href="#" @click="doTry()" style="color:#fff;">
                              <Badge count="0" overflow-count="99">
                                  <div class="flowList">
                                      <span class="topImg" ></span>
                                      <img class="imgContent" src="../../assets/icon/1-1.png" alt="" />
                                  </div>  
                                  <div class="flowInfo">采购合同</div> 
                              </Badge>
                            </a>
                        </div>

                        <div class="arrowBox">
                           <div id="triangle-facing-right"></div>
                        </div>

                        <div class="flowPart">
                          <a href="#" @click="doTry()" style="color:#fff;">
                              <Badge count="5" overflow-count="99">
                                  <div class="flowList">
                                      <span class="topImg" ></span>
                                     <img class="imgContent" src="../../assets/icon/1-2.png" alt="" />
                                  </div> 
                                  <div class="flowInfo">采购接收</div> 
                              </Badge>
                            </a>
                        </div>

                        <div class="arrowBox">
                           <div id="triangle-facing-right"></div>
                        </div>
                        
                        <div class="flowPart">
                          <a href="#" @click="doTry()" style="color:#fff;">
                              <Badge count="0" overflow-count="99">
                                  <div class="flowList">
                                      <span class="topImg" ></span>
                                      <img class="imgContent" src="../../assets/icon/1-3.png" alt="" />
                                  </div>  
                                  <div class="flowInfo">采购入库</div> 
                              </Badge>
                            </a>
                        </div>

                        <div class="arrowBox" style="width:30px">
                           <div id="triangle-facing-right" style="left:22px;"></div>
                        </div>

                         <div class="flowPart">
                          <a href="#" @click="doTry()" style="color:#fff;">
                              <Badge count="0" overflow-count="99">
                                  <div class="flowList">
                                       <span class="topImg" ></span>
                                      <img class="imgContent" src="../../assets/icon/1-4.png" alt="" />
                                  </div>
                                  <div class="flowInfo">采购发票</div>   
                              </Badge>
                            </a>
                        </div>
                        
                        <div class="arrowBox" style="width:20px">
                           <div id="triangle-facing-right" style="left:12px;"></div>
                        </div>

                         <div class="flowPart">
                          <a href="#" @click="doTry()" style="color:#fff;">
                              <Badge count="0" overflow-count="99">
                                  <div class="flowList">
                                      <span class="topImg" ></span>
                                      <img class="imgContent" src="../../assets/icon/1-5.png" alt="" />
                                  </div>
                                  <div class="flowInfo">付款申请</div>   
                              </Badge>
                            </a>
                        </div>
                   </li>
                   <li style="margin-bottom: 30px;">
                        <div class="flowPart" style="margin-left:-30px;margin-right:15px;">
                          <a href="#" @click="doTry()" style="color:#fff;">
                              <Badge count="0" overflow-count="99">
                                  <div class="flowList">
                                      <span class="topImg" ></span>
                                      <img class="imgContent" src="../../assets/icon/2-1.png" alt="" />
                                  </div>  
                                  <div class="flowInfo">平衡订货</div> 
                              </Badge>
                            </a>
                        </div>

                        <div class="flowPart">
                          <a href="#" @click="doTry()" style="color:#fff;">
                              <Badge count="0" overflow-count="99">
                                  <div class="flowList">
                                       <span class="topImg" ></span>
                                      <img class="imgContent" src="../../assets/icon/2-2.png" alt="" />
                                  </div>  
                                  <div class="flowInfo">加工指示</div> 
                              </Badge>
                            </a>
                        </div>

                        <div class="arrowBox" style="width:10px">
                           <div id="triangle-facing-right" style="left:2px;"></div>
                        </div>

                        <div class="flowPart">
                          <a href="#" @click="doTry()" style="color:#fff;">
                              <Badge count="0" overflow-count="99">
                                  <div class="flowList">
                                      <span class="topImg" ></span>
                                      <img class="imgContent" src="../../assets/icon/2-3.png" alt="" />
                                  </div> 
                                  <div class="flowInfo">加工排产</div> 
                              </Badge>
                            </a>
                        </div>

                        <div class="arrowBox" style="width:10px">
                           <div id="triangle-facing-right" style="left:2px;"></div>
                        </div>
                        
                        <div class="flowPart">
                          <a href="#" @click="doTry()" style="color:#fff;">
                              <Badge count="0" overflow-count="99">
                                  <div class="flowList">
                                      <span class="topImg" ></span>
                                      <img class="imgContent" src="../../assets/icon/2-4.png" alt="" />
                                  </div>  
                                  <div class="flowInfo">加工工单</div> 
                              </Badge>
                            </a>
                        </div>

                        <div class="arrowBox" style="width:10px">
                           <div id="triangle-facing-right" style="left:2px;"></div>
                        </div>

                         <div class="flowPart">
                          <a href="#" @click="doTry()" style="color:#fff;">
                              <Badge count="0" overflow-count="99">
                                  <div class="flowList">
                                     <span class="topImg" ></span>
                                      <img class="imgContent" src="../../assets/icon/2-5.png" alt="" />
                                  </div>
                                  <div class="flowInfo">加工领料</div>   
                              </Badge>
                            </a>
                        </div>
                        
                        <div class="arrowBox" style="width:30px">
                           <div id="triangle-facing-right" style="left:22px;"></div>
                        </div>

                         <div class="flowPart">
                          <a href="#" @click="doTry()" style="color:#fff;">
                              <Badge count="0" overflow-count="99">
                                  <div class="flowList">
                                      <span class="topImg" ></span>
                                      <img class="imgContent" src="../../assets/icon/2-6.png" alt="" />
                                  </div>
                                  <div class="flowInfo">加工实绩</div>   
                              </Badge>
                            </a>
                        </div>
                        <div class="arrowBox" style="width:20px">
                           <div id="triangle-facing-right" style="left:12px;"></div>
                        </div>
                        <div class="flowPart">
                          <a href="#" @click="doTry()" style="color:#fff;">
                              <Badge count="0" overflow-count="99">
                                  <div class="flowList">
                                     <span class="topImg" ></span>
                                      <img class="imgContent" src="../../assets/icon/2-3.png" alt="" />
                                  </div>
                                  <div class="flowInfo">加工入库</div>   
                              </Badge>
                            </a>
                        </div>
                   </li>
                   <li style="margin-bottom: 30px; position:relative;">
                       <div class="startBorder borderBottom">
                          
                       </div>

                        <div class="arrowBox">
                            <div id="triangle-facing-right"></div>
                        </div>

                        <div class="flowPart">
                          <a href="#" @click="doTry()" style="color:#fff;">
                              <Badge count="0" overflow-count="99">
                                  <div class="flowList">
                                      <span class="topImg" ></span>
                                      <img class="imgContent" src="../../assets/icon/3-1.png" alt="" />
                                  </div>  
                                  <div class="flowInfo">销售订单</div> 
                              </Badge>
                            </a>
                        </div>

                        <div class="arrowTop">
                            <div id="triangle-facing-top"></div>
                        </div>

                        <div class="arrowBox" style="width:40px">
                           <div id="triangle-facing-right" style="left:32px;"></div>
                        </div>

                        <div class="flowPart">
                          <a href="#" @click="doTry()" style="color:#fff;">
                              <Badge count="0" overflow-count="99">
                                  <div class="flowList">
                                      <span class="topImg" ></span>
                                      <img class="imgContent" src="../../assets/icon/3-2.png" alt="" />
                                  </div> 
                                  <div class="flowInfo">销售发货</div> 
                              </Badge>
                            </a>
                        </div>

                        <div class="arrowBottom">
                            <div id="triangle-facing-bottom"></div>
                        </div>
                        <div class="borderTop">
                          
                        </div>
                        <div class="borderLeft">
                          
                        </div>

                        <div class="arrowBox" style="width:40px">
                           <div id="triangle-facing-right" style="left:32px;"></div>
                        </div>
                        
                        <div class="flowPart">
                          <a href="#" @click="doTry()" style="color:#fff;">
                              <Badge count="0" overflow-count="99">
                                  <div class="flowList">
                                       <span class="topImg" ></span>
                                      <img class="imgContent" src="../../assets/icon/3-3.png" alt="" />
                                  </div>  
                                  <div class="flowInfo">销售配车</div> 
                              </Badge>
                            </a>
                        </div>

                        <div class="arrowBox" style="width:25px">
                           <div id="triangle-facing-right" style="left:17px;"></div>
                        </div>

                         <div class="flowPart">
                          <a href="#" @click="doTry()" style="color:#fff;">
                              <Badge count="0" overflow-count="99">
                                  <div class="flowList">
                                      <span class="topImg" ></span>
                                      <img class="imgContent" src="../../assets/icon/3-4.png" alt="" />
                                  </div>
                                  <div class="flowInfo">销售出库</div>   
                              </Badge>
                            </a>
                        </div>
                        
                        <div class="arrowBox" style="width:20px">
                           <div id="triangle-facing-right" style="left:12px;"></div>
                        </div>

                         <div class="flowPart">
                          <a href="#" @click="doTry()" style="color:#fff;">
                              <Badge count="0" overflow-count="99">
                                  <div class="flowList">
                                       <span class="topImg" ></span>
                                      <img class="imgContent" src="../../assets/icon/3-5.png" alt="" />
                                  </div>
                                  <div class="flowInfo">销售结算</div>   
                              </Badge>
                            </a>
                        </div>
                        <div class="arrowBox" style="width:20px">
                           <div id="triangle-facing-right" style="left:12px;"></div>
                        </div>
                        <div class="flowPart">
                          <a href="#" @click="doTry()" style="color:#fff;">
                              <Badge count="0" overflow-count="99">
                                  <div class="flowList">
                                       <span class="topImg" ></span>
                                      <img class="imgContent" src="../../assets/icon/3-6.png" alt="" />
                                  </div>
                                  <div class="flowInfo">销售开票</div>   
                              </Badge>
                            </a>
                        </div>
                        <div class="arrowBox" style="width:20px">
                           <div id="triangle-facing-right" style="left:12px;"></div>
                        </div>
                        <div class="flowPart">
                          <a href="#" @click="doTry()" style="color:#fff;">
                              <Badge count="0" overflow-count="99">
                                  <div class="flowList">
                                       <span class="topImg" ></span>
                                      <img class="imgContent" src="../../assets/icon/3-7.png" alt="" />
                                  </div>
                                  <div class="flowInfo">销售收款</div>   
                              </Badge>
                            </a>
                        </div>
                   </li>
                   <li style="position:relative;">
                      <div class="arrowBottom" style="height:26px;right: 115px;top: -27px;margin-left:0;">
                          <div id="triangle-facing-bottom" style="top: 17px;"></div>
                      </div>
                     <div class="flowPart" style="position: absolute;right: 85px;">
                          <a href="#" @click="doTry()" style="color:#fff;">
                              <Badge count="0" overflow-count="99">
                                  <div class="flowList">
                                       <span class="topImg" ></span>
                                      <img class="imgContent" src="../../assets/icon/3-8.png" alt="" />
                                  </div>
                                  <div class="flowInfo">销售收款</div>   
                              </Badge>
                            </a>
                        </div>
                   </li>
                 </ul>
                

                
               
               

            </div>
            <div class="flowChartRight" >
               <span  class="rightTitle">
                 可视化跟踪查询
               </span>
               <!-- 时间轴 -->
               <ul class="timeLine">
                  <li>
                      <div class="line"></div>
                      <div class="logoBox" style="background: linear-gradient(to bottom, rgb(50,70,149) 0%,rgb(20,20,60) 100%);">
                        <img class="timeImg" src="../../assets/icon/time1-1.png" alt="" />
                      </div>
                  </li>
                  <li>
                      <div class="line"></div>
                      <div class="logoBox" style="background: linear-gradient(to bottom, rgb(0,167,245) 0%,rgb(0,60,190) 100%);">
                        <!-- <Icon type="ios-paper" ></Icon> -->
                         <img class="timeImg" src="../../assets/icon/time1-2.png" style="left:7px;top:5px;" alt="" />
                      </div>
                      <div class="lineInfo">
                        <Icon type="arrow-left-b"></Icon>
                         <span>客户订货跟踪</span>
                      </div>
                  </li>
                  <li>
                    <div class="line"></div>
                    <div class="logoBox" style="background: linear-gradient(to bottom, rgb(47,240,106) 0%,rgb(17,110,70) 100%);">
                        <!-- <Icon type="ios-cart" style="left:6px;"></Icon> -->
                         <img class="timeImg" src="../../assets/icon/time1-3.png" style="left:5px;top:6px;"  alt="" />
                    </div>
                    <div class="lineInfo">
                      <Icon type="arrow-left-b"></Icon>
                      <span>
                        采购业务跟踪
                      </span>
                    </div>
                  </li>
                  <li>
                      <div class="line"></div>
                      <div class="logoBox" style="background: linear-gradient(to bottom, rgb(6,190,100) 0%,rgb(15,22,122) 100%);">
                        <!-- <Icon type="ios-loop-strong" style="left:4px;"></Icon> -->
                         <img class="timeImg" src="../../assets/icon/time1-4.png" style="left:4px;top:5px;"  alt="" />
                      </div>
                      <div class="lineInfo">
                        <Icon type="arrow-left-b"></Icon>
                        <span>生产业务跟踪</span>
                      </div>
                  </li>
                  <li>
                      <div class="line"></div>
                      <div class="logoBox" style="background: linear-gradient(to bottom, rgb(228,0,185) 0%,rgb(65,58,150) 100%);">
                        <!-- <Icon type="android-apps" style="left:7px;"></Icon> -->
                         <img class="timeImg" src="../../assets/icon/time1-5.png"  style="top:6px;left:5px;"   alt="" />
                      </div>
                      <div class="lineInfo">
                        <Icon type="arrow-left-b"></Icon>
                        <span>机组负荷跟踪</span>
                      </div>
                  </li>
                  <li>
                      <!-- <div class="line"></div> -->
                      <div class="logoBox" style="background: linear-gradient(to bottom, rgb(245,220,10) 0%,rgb(240,170,0) 100%);">
                        <!-- <Icon type="stats-bars"></Icon> -->
                         <img class="timeImg" src="../../assets/icon/time1-6.png" style="top:6px;"   alt="" />
                      </div>
                      <div class="lineInfo">
                        <Icon type="arrow-left-b"></Icon>
                        <span>产能预测</span>
                      </div>
                  </li>
              </ul>
            </div>
              
            </div>
          </div>

      </div>
</div>
     
</template>
<style scoped>
  ul,li{
    list-style: none;
  }
  .table-wrapper {
    overflow: scroll;
  }
  .flowChart{
    /*border:solid 1px red;*/
    width:670px;
    height:400px;
    color:#fff;
    display: inline-block;
  }
  .flowChartRight{
    width:150px;
    height:400px;
    color:#fff;
    display: inline-block;
    margin-left:100px;
    position: absolute;
  }
  .layout-menu-left {
    background: rgba(33,33,33,0.8);
    position: absolute;
    width: 200px;
    /*height: 100%;*/
    /*border-right: 1px solid lightgray;*/
    left: 0;
  }
  .ivu-menu-dark.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu), .ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu-title-active:not(.ivu-menu-submenu){
    color:#fff;
    border: none;
  }
  .layout-breadcrumb {
    padding: 8px 15px;
    background: #6E7B8B;
    /*border:solid 1px #000;*/
  }
  .ivu-breadcrumb a{
    border:solid 1px blue;
    color:#fff !important;
  }
  .layout-content-right {
    margin-left: 200px;
    position: relative;
    min-height: calc(100vh - 90px);
    min-height: -webkit-calc(100vh - 90px);
    min-width: -moz-calc(100vh - 90px);
  }
  .layout-content{
    background: none;
    /*border:solid 1px red;*/
  }
  .method-wrapper {
    float: left;
    margin-bottom: 10px;
  }

  .clearfix:after {
    content: ".";
    display: block;
    height: 0;
    visibility: hidden;
    clear: both;
  }
  .mRight{
    margin-right:10px;
  }
  .mLeft{
    margin-left:10px;
  }

  .rightTitle{
    display:inline-block;margin-bottom:10px;margin-left: -50px;
  }
  /*流程图*/
  .startBorder{
    width:0;
    height:80px;
    border-left: 2px solid #22b4fa;
    position: absolute;
    margin-top: 33px;
    margin-left: -2px;
  } 
  .borderBottom{
    margin-top: -30px;
    height: 65px;
  }
  .flowPart,.flowPart a{
    display: inline-block;
  }
  .flowList{
    width:60px;
    height:60px;
    text-align:center;
    border-radius:5px;
    border: 1px solid #22b4fa;
    box-shadow: 0 0 5px #22b4fa inset;
    position:relative;
    display: inline-block;
  }
  .flowList .topImg{
    width:60px;
    height:10px;
    background: url(../../assets/icon/top.png) no-repeat center;
    background-size: 100%;
    position: absolute;
    left: -1px;
    top:-1px;
  }
  .flowList .imgContent{
    position: relative;
    top: 17px;
  }
  .flowList i{
    font-size: 30px;
    line-height: 65px;
  }
  .flowInfo{
    width: 60px;
    text-align: center;
    margin-top: 10px;
    font-size: 12px;
  }
  .arrowBox{
    display: inline-block;
    border-top: solid 2px #22b4fa;
    width:46px;
    position: relative;
    margin-left: -2px;
    top: -10px;
  }
  .arrowTop{
     display: inline-block;
     border-left: solid 2px #22b4fa;
      height:28px;
      position: absolute;
      margin-left: -35px;
      top: -29px;
  }
  .arrowBottom{
     display: inline-block;
     border-left: solid 2px #22b4fa;
     height:12px;
     position: absolute;
     margin-left: -35px;
     top: -16px;
  }
  #triangle-facing-top {  
      display: inline-block;  
      border-right: 2px solid #22b4fa;
      border-top: 2px solid #22b4fa;
      width: 8px;
      height: 8px;
      transform: rotate(-45deg);
      position: absolute;
      top: 0px;
      left: -5px;
  }
  #triangle-facing-bottom {  
      display: inline-block;  
      border-left: 2px solid #22b4fa;
      border-bottom: 2px solid #22b4fa;
      width: 8px;
      height: 8px;
      transform: rotate(-45deg);
      position: absolute;
      top: 3px;
      left: -5px;
  }
  #triangle-facing-right {  
      display: inline-block;  
      border-right: 2px solid #22b4fa;
      border-bottom: 2px solid #22b4fa;
      width: 8px;
      height: 8px;
      transform: rotate(-45deg);
      position: absolute;
      top: -5px;
      left: 37px;
  }
  .borderTop{
    width: 300px;
    height: 0;
    position: absolute;
    top: -17px;
    left: 183px;
    border-top: 2px solid #22b4fa;
  }
  .borderLeft{
    width: 0;
    height: 15px;
    position: absolute;
    top: -30px;
    left: 483px;
    border-left: 2px solid #22b4fa;
  }

  /*时间轴*/
  .timeLine{
    margin-top: 10px;
  }
  .timeLine li{
    /*border:solid 1px red;*/
    position: relative;
  }
  .timeLine .line{
    width: 100%;
    height: 62px;
    border-left: solid 4px rgb(136,146,156);
  }
  .timeLine .logoBox{
    width:34px;
    height:34px;
    border-radius: 50%;
    border: solid 3px rgb(136,146,156);
    position: absolute;
    left: -15px;
    top: -12px;
    z-index: 9;
    /*background:-moz-linear-gradient(top, #000000 0%, #ffffff 100%);
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,#000000), color-stop(100%,#ffffff));
    background: -webkit-linear-gradient(top, #000000 0%,#ffffff 100%);
    background: -o-linear-gradient(top, #000000 0%,#ffffff 100%);
    background: -ms-linear-gradient(top, #000000 0%,#ffffff 100%);*/
    /*background: linear-gradient(to bottom, #000000 0%,#ffffff 100%);*/
  }
  .timeLine .logoBox .timeImg{
    position: absolute;
    top: 5px;
    left: 6px;
    font-size: 16px;
  }
  .timeLine .lineInfo{
      position: absolute;
      top: 14px;
      left: 35px;
  }
  .timeLine .lineInfo i{
    color:rgb(17,96,130);
    position: absolute;
    left: -6px;
    top: -18px;
    font-size: 16px
  }
   .timeLine .lineInfo span{
    color: #fff;
    background: rgb(17,96,130);
    padding: 5px;
    text-align: center;
    width: 110px;
    display: block;
    position: relative;
    top: -25px;
  }

  /*.demo-badge{
      width: 42px;
      height: 42px;
      background: #eee;
      border-radius: 6px;
      display: inline-block;
  }*/
  
</style>
<script>
  import api from '../../api/apinew'
  import leftBar from '../../components/leftBar'
  import axios from 'axios'
  import Qs from 'qs'
  export default{
    data(){
      return {
        isLeftHiden: false,
        
      }
    },
    methods: {
      toggleClick () {
        this.isLeftHiden = !this.isLeftHiden;
      },
      togglemobileauto(ismobile){
        this.isLeftHiden = ismobile
      },
      doTry:function(){
        alert(22);
      }

    },
    components: {
      leftBar,
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?bd1a849a